export var mergeUrl = function (url, search) {
    return url.includes("?") ? "".concat(url).concat(search.replace("?", "&")) : "".concat(url).concat(search);
};
